// Module-scope so React doesn't recreate it every render. Used by the
// chat DAG fan-expansion state (collapsed peer-fan ids).
type FanAction = { type: 'toggle'; id: string };

export function fanReducer(
  state: ReadonlySet<string>,
  action: FanAction,
): ReadonlySet<string> {
  if (action.type !== 'toggle') return state;
  const next = new Set(state);
  if (next.has(action.id)) next.delete(action.id);
  else next.add(action.id);
  return next;
}
